export enum PdfAttachmentType {
  Document = 'document',
  Image = 'image',
}
